import LoginModule from './modules/LoginModule'
import AdminUsersModule from './modules/AdminUsersModule'
import OrganisationModule from './modules/OrganisationModule'
import ThemeModule from './modules/ThemeModule'
import MasterModule from './modules/MasterModule'
import CompanionModule from './modules/CompanionModule'
import NaiConnectModule from './modules/NaiConnectModule'

const api = {
  ...LoginModule,
  ...AdminUsersModule,
  ...OrganisationModule,
  ...ThemeModule,
  ...MasterModule,
  ...CompanionModule,
  ...NaiConnectModule,
}
export default api
